import { Injectable } from '@angular/core';
import createKindeClient, { AuthOptions, GetTokenOptions, KindeClient, KindeClientOptions } from '@kinde-oss/kinde-auth-pkce-js';
import { BehaviorSubject, Observable, of, throwError } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class KindeClientService {
    private readonly kindeClientSubject: BehaviorSubject<KindeClient> = new BehaviorSubject(null);

    isAuthenticated(): Observable<boolean> {
        return this.kindeClientSubject.asObservable().pipe(
            take(1),
            switchMap((kinde: KindeClient) => {
                if (!kinde) {
                    return of(false);
                }

                return kinde.isAuthenticated();
            }),
        )
    }

    login(options?: AuthOptions): Observable<void> {
        return this.kindeClientSubject.asObservable().pipe(
            take(1),
            switchMap((kinde: KindeClient) => {
                if (!kinde) {
                    return throwError('Kinde is not initialized');
                }
                return kinde.login(options);
            }),
        )
    }

    logout(): Observable<void> {
        return this.kindeClientSubject.asObservable().pipe(
            take(1),
            switchMap((kinde: KindeClient) => {
                if (!kinde) {
                    return throwError('Kinde is not initialized');
                }
                return kinde.logout();
            }),
        )
    }

    getToken(options?: GetTokenOptions): Observable<string> {
        return this.kindeClientSubject.asObservable().pipe(
            take(1),
            switchMap((kinde: KindeClient) => {
                if (!kinde) {
                    return throwError('Kinde is not initialized');
                }
                return kinde.getToken(options);
            }),
        )
    }

    initiate(options: KindeClientOptions): Promise<KindeClient> {
        return createKindeClient(options).then((value: KindeClient) => {
            this.kindeClientSubject.next(value);

            return value;
        });
    }
}
